module.exports = __webpack_public_path__ + "media/reskin-images/icon--check-circle-purple-775eb245.svg";